import { Box, Card, CardContent, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { AdopterDto } from '../../interactors/gen/backendClient'
import { useAccountsStore } from '../../store/AccountsStore'
import { theme } from '../theme'
import { TabKey } from './AdopterDetailsScreen'
import { EditAdopterGeneralInfoPrompt } from './EditAdopterGeneralInfoPrompt'

interface Props {
  adopter: AdopterDto
  isOwnAccount: boolean
  onSubmit: (data: Partial<AdopterDto>) => Promise<void>
  isLoading: boolean
  changeTab: (_: React.SyntheticEvent, newTabKey: TabKey) => void
}

export const AdopterGeneralInfo: React.FC<Props> = ({ adopter, isOwnAccount, onSubmit, isLoading }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const accountsStore = useAccountsStore()

  /* const sendFormMutation = useMutation(
    async () => {
      const config = {
        method: 'POST',
        url: 'adopters-platform/auth/create-password/request',
        data: {
          adopterId: adopter.id,
          customerId: adopter.customerId,
        },
      }
      const response = await backendClient(config)
      return response
    },
    {
      onSuccess: () => {
        globalSnackBarStore.triggerSuccessMessage(`Le formulaire a été envoyé par email à ${adopter.firstName}!`)
        adopter.profileHasBeenAccepted = AdopterDtoProfileHasBeenAccepted.FormSent
      },
    }
  ) */
  return (
    <Card
      sx={{
        mt: { xs: 'auto', sm: 2 },
        px: { xs: 'auto', sm: 2 },
      }}
    >
      <CardContent sx={{ '&:last-child': { pb: isMobile ? '16px' : 'auto' } }}>
        <Box display="flex" flexDirection="row" justifyContent="space-between" gap={2} alignItems="flex-start">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              width: '100%',
              fontSize: '16px',
              gap: 1,
            }}
          >
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, minmax(0, 1fr))' },
                gap: { xs: 1.25, sm: 2.25 },
                alignItems: 'start',
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: '0.74rem', fontWeight: 600, color: '#8E97AA', letterSpacing: '0.01em' }}>
                  Email
                </Typography>
                <Typography
                  sx={{
                    mt: 0.15,
                    fontSize: '0.92rem',
                    fontWeight: 400,
                    color: '#4A556E',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  title={adopter?.email || ''}
                >
                  {adopter?.email || '-'}
                </Typography>
              </Box>

              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: '0.74rem', fontWeight: 600, color: '#8E97AA', letterSpacing: '0.01em' }}>
                  Téléphone
                </Typography>
                <Typography
                  sx={{
                    mt: 0.15,
                    fontSize: '0.92rem',
                    fontWeight: 400,
                    color: '#4A556E',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  title={adopter?.phoneNumber || ''}
                >
                  {adopter?.phoneNumber || '-'}
                </Typography>
              </Box>

              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontSize: '0.74rem', fontWeight: 600, color: '#8E97AA', letterSpacing: '0.01em' }}>
                  Adresse
                </Typography>
                <Typography
                  sx={{
                    mt: 0.15,
                    fontSize: '0.92rem',
                    fontWeight: 400,
                    color: '#4A556E',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  title={
                    adopter.address && adopter.postalCode && adopter.city
                      ? `${adopter.address}, ${adopter.postalCode} ${adopter.city}`
                      : 'Adresse non renseignée'
                  }
                >
                  {adopter.address && adopter.postalCode && adopter.city
                    ? `${adopter.address}, ${adopter.postalCode} ${adopter.city}`
                    : 'Adresse non renseignée'}
                </Typography>
              </Box>
            </Box>
          </Box>
          {accountsStore.canEdit() && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexShrink: 0, pl: { xs: 0.5, sm: 1.5 } }}>
              <EditAdopterGeneralInfoPrompt
                adopter={adopter}
                isOwnAccount={isOwnAccount}
                onSubmit={onSubmit}
                isLoading={isLoading}
              />
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  )
}
